export default __webpack_public_path__ + "static/media/home-slider.f02633c4.mp4";